export const SHOW_EXPERIMENT = 'SHOW_EXPERIMENT'

export const showExperiment = (experiments) => ({
  type: SHOW_EXPERIMENT,
  payload: experiments,
})
